// test2547
(2547 && 0);
